module.exports = __webpack_public_path__ + "static/media/handbags_getty_mobile.63f2d7d1.jpg";